import { createFileRoute } from '@tanstack/react-router'

import PageSettingsCharacters from '@/pages/PageSettingsCharacters'

export const Route = createFileRoute('/settings/characters/')({
  component: PageSettingsCharacters
})
